<template>
    <div class="serviceRoot" id="serviceId" >
        <div  class="servciceTitle" >
            <!-- <div class="name">Amount</div> -->
            <div class="name">
                <div class="nameTool">
                    <el-tooltip class="item" effect="dark" placement="right">
                        <div slot="content">
                            A priority token represents the importance or weight of a service. The more tokens a service has, the higher its priority in processing or allocation.
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#FEAE00"/>
                        </svg>
                    </el-tooltip>
                </div>
                <strong> Priority Token</strong>
               
                
            </div>
            <div class="pritokenNum">{{ priToken }}</div>
            <div class="dotBlock">
                <div class="dotItem" v-for="item in 8" :key="item" :style="{background:priToken>=item?'#FEAE00':''}"></div>
            </div>
            <!-- <div class="name">Serves</div> -->
        </div>
        <div class="explainLine"> 
            Each service is assigned <strong>priority tokens</strong> that determine its weight in the system.
By default, there are <strong>8 tokens,</strong> evenly distributed across all services. <br/>
You can adjust the priority by <strong>reducing tokens from one service and reallocating them to others,</strong> based on your needs.
 
        </div>
        <div class="servciceLine" v-for="(item, index) in serviceArr" :key="index">
            <div class="serviceLeft">
                <div class="leftBlock">
                    <div class="leftItem">
                        <div class="nameItem">
                           <div>{{ item.name }}</div> 
                           <div class="toolBlock" @click.stop="showPic(item.picObj)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                                    <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#FEAE00"/>
                                </svg>
                                <!-- <el-tooltip class="item" effect="dark" placement="right">
                                    <div slot="content">
                                        <img :src="imgObj.service001" style="width: 100%;height: auto;" alt="">
                                       
                                    </div>
                                    
                                </el-tooltip> -->
                            </div>
                        </div>
                        <!-- <div class="desecriptItem">{{`Estimated Daily Costs = $${item.perAmount}`}}</div> -->
                    </div>
                    <div class="leftItem">
                        <div class="subtitle">{{ item.subtitle }}</div>

                    </div>
                    <div class="leftItem" v-if="item.currentNum >item.currentMaxData">
                        <div class="prompt">You have reached the maximum monthly outreach limit. It is recommended to add your priority token through other services. </div>
                    </div>
                    <div class="leftItem">
                        <div class="desecriptItem">{{`Daily Costs* : $${item.perAmount}`}}</div>
                    </div>
                    <div class="leftItem">

                        <div class="lasstLine"  @click.capture.stop>
                            <div class="progressItem">
                                <el-input-number size="medium"  v-model="item.perNum" @change="handleInputChange"  :step="1" :min=0 :max="inputMax[index]"  ></el-input-number>
                            </div>
                            <div class="numLine">
                                <div class="realItem">{{'Monthly Impressions*'}}</div>
                                <div class="toolBlock">
                                    <el-tooltip :content="item.mark" class="item" effect="dark" placement="right-start" popper-class="top-tip" >
                                        <el-tooltip  :content="item.mark2" class="item" effect="dark" placement="right-end" popper-class="bottom-tip"  >
                                            <span class="target-element">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#FEAE00"/>
                                                </svg>
                                            </span>
                                        </el-tooltip>
                                    </el-tooltip>
                                </div>
                                <div class="increaseItem">{{ item.currentNum==1?0:item.currentNum >item.currentMaxData?item.currentMaxData:item.currentNum  }}</div>
                                <!-- <div class="totalItem">{{ ` / ${item.currentMaxData} `}}</div> -->
                            </div>
                        </div>
                       
                    </div>
                    
                </div>
                <div class="leftItem" style="margin-top: 6px;">
                        <div class="desecriptItem">*Estimated value</div>
                    </div>
            </div>
            <div class="serviceRight">
                <line-Chartset :chart-data="item.totalNumArr"  :optionNum="item.currentNum" />
            </div>
        </div>

        <el-dialog class="picDialog" title="" modal-append-to-body :visible.sync="dialogShow1" >
            <template #modal>
                <div class="custom-modal"></div>
            </template>
            <div>
                <img v-for="item in dialogPic" :key="item" :src="require(`@/assets/img/main/${item}`)" style="width: 100%;height: auto;" alt="">

            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog } from 'element-ui';
import {serviceData} from './js/service'
import LineChartset from './lineChartOfset.vue';

export default {
    components: {LineChartset },
    props:['serviceNum','serviceLevel','defaultNum','currentAmount'],
    data() {
      return {
        imgObj:{
            service001:require("../../assets/img/main/service001.jpeg"),
        },
        serviceArr:[],
        serviceOptions:{},
        retMassage:'',
        priToken:0,
        inputMax:[2,2,2,2],
        defauleWeight:[2,2,2,2],
        dialogPic:[],
        dialogShow1:false
      }
    },
    watch: {
        // currentAmount:{
        //     deep: true,
        //     handler(newVal) {
        //         console.log('serviceLevel',newVal,this.serviceLevel)
        //         this.changeService();

        //     }
        // },
        serviceNum: {
            deep: true,
            handler(newVal) {
                console.log('serviceNum 当前第几个套餐',this.serviceNum,this.currentAmount,)
                // setTimeout(()=>{
                    this.changeService();

                // },1000)

            }
        },
        defaultNum: {
            deep: true,
            handler(newVal) {
                this.serviceArr = JSON.parse(JSON.stringify(serviceData)) 
                console.log('rrrrr', this.serviceArr)
                for(let i in this.serviceArr){
                    console.log('perNum',i, this.serviceArr[i].perNum)
                    this.serviceArr[i].perNum = this.defauleWeight[i]
                    this.serviceLevel[i] = this.defauleWeight[i]
                    this.inputMax[i] = this.defauleWeight[i]
                    this.serviceArr[i].perAmount = (this.currentAmount*2/240).toFixed(2)
                }
                this.priToken = 0
                console.log(' this.serviceArr', this.serviceArr,this.serviceLevel)
        

            }
        },
    },
    mounted: function() {
        let userData = JSON.parse(localStorage.getItem('userData'))
        console.log('userData333',userData)
        if(userData&&userData.weight&&userData.weight.length){
            console.log(3333333,)
            this.defauleWeight= [...userData.weight]
      }

        this.serviceArr = JSON.parse(JSON.stringify(serviceData))  
        console.log('2qwdddddd',serviceData,this.serviceArr,this.serviceLevel,this.currentAmount,this.serviceNum)
        this.changeService()
    },
    methods:{
        showPic(obj){
            // dialogPic:[],\
            console.log('obj',obj)
            this.dialogPic = [...obj]
            this.dialogShow1 = true
        },
        changeService(){
            if(!this.serviceLevel.length){
                this.serviceLevel = [...this.defauleWeight]
            }
            this.priToken = 0
            for(let i in this.serviceArr){
                let index = parseInt(this.serviceNum[0]-1) 
                if(index>=10){
                    index = index-10
                }
                console.log('qqqqqqqqqqq',this.serviceArr,i,index)
                this.serviceArr[i].currentData = this.serviceArr[i].basicVlaue[index]
                let maxNum = this.serviceArr[i].currentData * 8
                this.serviceArr[i].currentMaxData = maxNum >this.serviceArr[i].maxNum?this.serviceArr[i].maxNum:maxNum
            }
            if(this.serviceLevel &&this.serviceLevel.length){
                // this.serviceLevel=[1,2,3,0]
                this.retMassage = ''
                for(let i in this.serviceLevel){
                    console.log('this.serviceLevel[i]',this.serviceLevel[i],this.currentAmount)
                    if(parseFloat(this.serviceLevel[i])==1){
                        this.serviceArr[i].numberOfPices=33.3
                    }else if(parseFloat(this.serviceLevel[i])==2){
                        this.serviceArr[i].numberOfPices=66.6
                    }else if(parseFloat(this.serviceLevel[i])>=3){
                        this.serviceArr[i].numberOfPices=99.9
                    }else{
                        this.serviceArr[i].numberOfPices=0
                    }
                    // console.log('1aaaaaas',this.serviceArr,i,this.serviceArr[i].currentData,this.serviceLevel[i])
                    this.serviceArr[i].currentNum = this.serviceArr[i].currentData *this.serviceLevel[i]
                    if(this.serviceLevel[i]){
                        this.serviceArr[i].perAmount = (this.currentAmount*this.serviceLevel[i]/240).toFixed(2)

                    }else{
                        this.serviceArr[i].perAmount = 0
                    }
                    this.serviceArr[i].perNum = parseInt(this.serviceLevel[i])
                    this.inputMax[i] = parseInt(this.serviceLevel[i])
                    console.log(' this.serviceArr[i]', this.serviceArr[i])
                }
                
            }else{
                this.handleInputChange()
                // this.handleChangeSlider()
            }
            this.$forceUpdate()
        },
        handleInputChange(	currentValue, oldValue,event){
    //         console.log(event)
        
    //         if (window.event) {
    //     window.event.stopPropagation(); // 兼容旧浏览器
    //   }
            // event.stopPropagation()
                this.retMassage = ''
                console.log(this.serviceArr)
                let totalNum = 0
                let proportArr = []
                for(let i in this.serviceArr){
                    totalNum += this.serviceArr[i].perNum
                    proportArr.push(this.serviceArr[i].perNum)
                    this.serviceArr[i].perAmount = (this.currentAmount*this.serviceArr[i].perNum/240).toFixed(2)

                }
                if(totalNum<=8){
                    this.priToken = 8-totalNum
                }
                for(let j in this.inputMax){
                    this.inputMax[j] = this.priToken + this.serviceArr[j].perNum
                }
                for(let k in this.serviceArr){
                    this.serviceArr[k].currentNum  = this.serviceArr[k].currentData *this.serviceArr[k].perNum
                }
                if( totalNum<8){
                     this.retMassage = `There are still Priority Tokens not set.` //还有Priority Token没有设置，请重新设置
                }
                console.log('proportArr',proportArr)
                this.$forceUpdate()

                this.$emit('sendMessage',  this.retMassage,proportArr);

        },
        handleChangeSlider(){
            let totleProport = 0
            let proportArr = []
            this.retMassage = ''
            for(let i in this.serviceArr){

                if(this.serviceArr[i].numberOfPices==33.3){
                    totleProport +=1
                    proportArr.push(1)
                    this.serviceArr[i].currentNum = this.serviceArr[i].currentData *1
                    this.serviceArr[i].perAmount = (this.currentAmount*1/240).toFixed(2)
                }else if(this.serviceArr[i].numberOfPices==66.6){
                    totleProport +=2
                    proportArr.push(2)
                    this.serviceArr[i].currentNum = this.serviceArr[i].currentData *2
                    this.serviceArr[i].perAmount = (this.currentAmount*2/240).toFixed(2)
                }else if(this.serviceArr[i].numberOfPices==99.9){
                    totleProport +=3
                    proportArr.push(3)
                    this.serviceArr[i].currentNum = this.serviceArr[i].currentData *3
                    this.serviceArr[i].perAmount = (this.currentAmount*3/240).toFixed(2)
                }else{
                    this.serviceArr[i].currentNum =1
                    this.serviceArr[i].perAmount = 0
                    proportArr.push(0)
                }

                
            }
            if(totleProport<8 && totleProport>2){
                let indices = []
                proportArr.forEach((item, index) => {
                    if (item === 3) {
                        indices.push(index);
                    }
                });
                console.log('indices',indices)
                if(indices.length == 1){
                    let coefficient = 8-totleProport +3
                    this.serviceArr[indices[0]].currentNum = this.serviceArr[indices[0]].currentData*coefficient 
                    this.serviceArr[indices[0]].perAmount = (this.currentAmount*coefficient/240).toFixed(2)
                    proportArr[indices[0]] = coefficient
                }else if(indices.length == 2){
                    if(totleProport ==6){
                        this.serviceArr[indices[0]].currentNum = this.serviceArr[indices[0]].currentData*4 
                        this.serviceArr[indices[1]].currentNum = this.serviceArr[indices[1]].currentData* 4
                        this.serviceArr[indices[0]].perAmount = (this.currentAmount*4/240).toFixed(2)
                        this.serviceArr[indices[1]].perAmount = (this.currentAmount*4/240).toFixed(2)

                        proportArr[indices[0]] = 4
                        proportArr[indices[1]] = 4
                    }else{
                        this.serviceArr[indices[0]].currentNum = Math.ceil(this.serviceArr[indices[0]].currentData*3.5) 
                        this.serviceArr[indices[1]].currentNum = Math.ceil(this.serviceArr[indices[1]].currentData*3.5)
                        this.serviceArr[indices[0]].perAmount = (this.currentAmount*3.5/240).toFixed(2)
                        this.serviceArr[indices[1]].perAmount = (this.currentAmount*3.5/240).toFixed(2)
                        proportArr[indices[0]] = 3.5
                        proportArr[indices[1]] = 3.5
                    }
                }else{
                    this.retMassage = `比重值为${totleProport}，不满8请重新设置`
                }
            }else if(totleProport>8){
                this.retMassage = `比重值为${totleProport}，请重新设置`
            }else if(totleProport<3){
                this.retMassage = `比重值为${totleProport}，不满8请重新设置.`
            }
            console.log('proportArr', this.serviceArr)
            this.$emit('sendMessage',  this.retMassage,proportArr);
        }
    }
}
</script>

<style  lang="scss" >
.top-tip{
    margin-top: 25px;
}
.bottom-tip{
    // margin-bottom: 30px;
}
.v-modal{
    z-index: 199 !important;
}
.picDialog {
    z-index:999999999 !important;
    .el-dialog{
        width: 80% !important;
        max-width: 1200px !important;
    }
}

    #serviceId{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 40px;
        .servciceTitle{
            display: flex;
            gap: 8px;
            margin-bottom: -20px;
            .dotBlock{
                display:flex;
                gap:6px;
                align-items:center;
                .dotItem{
                    width:16px;
                    height:16px;
                    border-radius:50%;
                    background:#E0E0E0;
                }
            }
            .pritokenNum{
                color: #000;
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }
            .name{
                // width: 50%;
                color: #000;
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px; /* 110% */
                position: relative;
                margin-right: 16px;
            }
            .nameTool{
                position: absolute;
                right: -16px;
                top:-8px;
            }
        }
        .explainLine{
            word-break:  break-word;
            color:#000;
            font-size: 14px;
            line-height: 1.4;
        }
        .servciceLine{
            margin-top: -20px;
            display: flex;
            gap: 30px;
            .serviceLeft{
                width: 50%;
                // height: 200px;
                padding-top: 20px;
                .leftBlock{
                    height: 100%;
                    border-radius: 16px;
                    background: rgba(0, 0, 0, 0.03);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 16px;
                    box-sizing: border-box;
                }
                .leftItem{
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    .prompt{
                        word-break:  break-word;
                        color: #EE6666;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.2;
                    }
                    .nameItem{
                        word-break:  break-word;

                        display: flex;
                        gap:8px;
                        color: #000;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 22px; /* 110% */
                        .toolBlock{
                            cursor: pointer;
                            
                        }
                    }
                    .subtitle{
                        word-break:  break-word;
                        color: #000;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }
                    .lasstLine{
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                    }
                    .desecriptItem{
                        word-break:  break-word;
                        color: #999;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }
                    .numLine{
                        display: flex;
                        align-items: flex-end;
                        gap: 4px;
                        position: relative;
                        .realItem{
                            word-break:  break-word;
                            color: #999;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        .serviceImg{
                            width: 14px;
                            height: auto;
                        }
                        .increaseItem{
                            position: absolute;
                            width: 80%;
                            top:-36px;
                            right: 10%;
                            text-align: right;
                            color: #FEAE00;
                            font-size: 32px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        .totalItem{
                            color: #999;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                    }
                    .progressItem{
                        .el-progress.is-warning .el-progress-bar__inner{
                            background: #FEAE00;
                        }
                        .el-input-number--medium{
                            max-width:120px !important;

                        }
                        .el-input-number{
                            max-width:120px !important;

                        }
                    }
                }
            }
            .serviceRight{
                width: 50%;
                height: 180px;
                // background: #999;
            }
        }
    }

    @media screen and (min-width: 767px) and (max-width: 1200px){
        #serviceRoot{
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 4vw;
            .servciceTitle{
                display: flex;
                gap: 1vw;
                margin-bottom: -2vw;
                .pritokenNum{
                    color: #000;
                    font-size: 2vw;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 2.2vw;
                }
                .name{
                    // width: 50%;
                    color: #000;
                    font-size: 2vw;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 2.2vw; /* 110% */
                }
            }
            .explainLine{
                color:#000;
                font-size: 1.4vw;
                line-height: 1.4;
            }
            .servciceLine{
                margin-top: -2vw;
                display: flex;
                gap: 30px;
                .serviceLeft{
                    width: 50%;
                    // height: 200px;
                    padding-top: 2vw;
                    .leftBlock{
                        height: 100%;
                        border-radius: 16px;
                        background: rgba(0, 0, 0, 0.03);
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        padding: 1.6vw 2.4vw;
                        box-sizing: border-box;
                    }
                    .leftItem{
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        
                        .prompt{
                            color: #EE6666;
                            font-size: 1.2vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 1.2;
                        }
                        .nameItem{
                            color: #000;
                            font-size: 1.8vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 2.2vw; /* 110% */

                            display: flex;
                            gap: 8px;
                            .toolBlock{
                                cursor: pointer;
                                display: inline-flex;
                                justify-content: center;
                                align-content: center;
                                
                            }
                        }
                        .desecriptItem{
                            color: #999;
                            font-size: 1.4vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        .numLine{
                            display: flex;
                            align-items: flex-end;
                            gap: 0.4vw;
                            .realItem{
                                color: #000;
                                font-size: 1.4vw;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                            }
                            .serviceImg{
                                width: 1.4vw;
                                height: auto;
                            }
                            .increaseItem{
                                color: #FEAE00;
                                font-size: 1.4vw;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                            }
                            .totalItem{
                                color: #999;
                                font-size: 1.8vw;
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                            }
                        }
                        .progressItem{
                            .el-progress-bar__outer{
                                height: 1.4vw !important;
                            }
                        }
                    }
                }
                .serviceRight{
                    width: 50%;
                    height: 18vw;
                    // background: #999;
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        #serviceId{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 6vw;
        .servciceTitle{
            display: flex;
            gap: 2vw;
            margin-bottom: -2vw;
            .dotBlock{
                display:flex;
                gap:1vw;
                align-items:center;
                .dotItem{
                    width:3vw;
                    height:3vw;
                    border-radius:50%;
                    background:#E0E0E0;
                }
            }
            .pritokenNum{
                color: #000;
                font-size: 3.4vw;
                font-style: normal;
                font-weight: 400;
                line-height: 2; 
            }
            .name{
                // width: 50%;
                color: #000;
                font-size: 3.4vw;
                font-style: normal;
                font-weight: 400;
                line-height: 2; /* 110% */
            }
        }
        .explainLine{
            color:#000;
            font-size: 2.4vw;
            line-height: 1.4;
        }
        .servciceLine{
            margin-top: -1vw;
            display: flex;
            gap: 4vw;
            .serviceLeft{
                width: 50%;
                // height: 200px;
                padding-top: 1vw;
                .leftBlock{
                    height: 100%;
                    border-radius: 2vw;
                    background: rgba(0, 0, 0, 0.03);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding:2vw  3vw ;
                    box-sizing: border-box;
                }
                .leftItem{
                    display: flex;
                    flex-direction: column;
                    gap: 1vw;
                    .subtitle{
                        word-break:  break-word;
                        color: #000;
                        font-size: 2vw;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }
                    .prompt{
                        color: #EE6666;
                        font-size: 2.4vw;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.2;
                    }
                    .nameItem{
                        display: flex;
                        gap:1vw;
                        color: #000;
                        font-size: 2.4vw;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 1.5; /* 110% */
                        .toolBlock{
                            cursor: pointer;
                            
                        }
                    }
                    .desecriptItem{
                        color: #999;
                        font-size: 2vw;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }
                    .numLine{
                        display: flex;
                        align-items: flex-end;
                        gap: 1vw;
                        .realItem{
                            color: #000;
                            font-size: 2vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        .serviceImg{
                            width: 1vw;
                            height: auto;
                        }
                        .increaseItem{
                            width: auto;
                            position: relative;
                            right: 0;
                            top: 0;
                            color: #FEAE00;
                            font-size: 2.4vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                        .totalItem{
                            color: #999;
                            font-size: 3vw;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                    }
                    .progressItem{
                        // height: 8vw;
                        // border: 1px solid #DCDFE6;
                        .el-progress.is-warning .el-progress-bar__inner{
                            background: #FEAE00;
                        }
                        .el-input-number--medium{
                            max-width:120px !important;

                        }
                        .el-input-number{
                            max-width:120px !important;

                        }
                        .el-input-number--medium .el-input-number__decrease, .el-input-number--medium .el-input-number__increase{
                            width:6vw;
                            font-size: 2.8vw;
                            line-height: calc(8vw - 2px) ;
                        //  border: 1px solid #DCDFE6;

                        }
                        .el-input-number--medium{
                           
                            line-height: calc(8vw - 2px);
                        }
                    }
                    .lasstLine{
                        width: 100%;
                        display: flex;
                        gap: 1vw;
                        flex-direction: column-reverse;
                        justify-content: flex-start;
                        align-items: flex-start;
                    }
                }
            }
            .serviceRight{
                width: 50%;
                height: 35vw;
                // background: #999;
            }
        }
    }
    }
</style>